import React from 'react'
import { PixelFlexBox, Section, SectionHeader, SectionTitle } from 'pixel-base'

import CollapsedPaymentOption from './components/CollapsedPaymentOption'

const CustomerPaymentMethods = (props) => {
  const { customer } = props

  const [paymentMethods, setPaymentMethods] = React.useState<any>(
    props.paymentMethods,
  )
  React.useEffect(() => {
    setPaymentMethods(paymentMethods)
  }, [customer])

  return (
    <>
      <PixelFlexBox
        style={{
          flexDirection: 'column',
          flexWrap: 'nowrap',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          alignContent: 'center',
          width: ' 100%',
          padding: '10px 0',
          overflow: 'auto',
          height: '90%',
        }}
      >
        <Section style={{ overFlow: 'auto' }}>
          <SectionHeader>
            <SectionTitle>Payment Methods</SectionTitle>
          </SectionHeader>
          <PixelFlexBox
            style={{
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              alignContent: 'flex-start',
              overflow: 'auto',
            }}
          >
            {paymentMethods?.map((item, index) => {
              return (
                <CollapsedPaymentOption
                  key={index}
                  data={customer}
                  item={item}
                  method_type={item.type}
                />
              )
            })}
          </PixelFlexBox>
        </Section>
      </PixelFlexBox>
    </>
  )
}

export default CustomerPaymentMethods
